import { opsHttp } from "../auth/apiClient.ts";
import type { ExchangeDto } from "./dto.ts";

export async function getExchanges<T = ExchangeDto>(): Promise<T[]> {
  const { data } = await opsHttp.get<T[]>("/api/Exchanges");
  return data ?? [];
}